import setSMSProviders from './set-sms-providers'
import setProviderDefaults from './set-provider-defaults'

const mutations = {
  setSMSProviders,
  setProviderDefaults,

  setStripe(state, payload: any) {
    state.stripe = payload
  },

  startLoading(state) {
    state.loading = true
  },

  stopLoading(state) {
    state.loading = false
  },
}


export default mutations
